import { http_client } from "@/plugins/http_client";

const url = '/api/v1/solicitud'
const bolsa_empleo_url = `${process.env.VUE_APP_URL_API_BOLSA_EMPLEO}`
const getSolicitudes = async (params = {}) => await http_client(`${url}`, params, 'get')
const getFases = async (numFase, params = {}) => await http_client(`${url}/fase/${numFase}`, params, 'get')
const getObservaciones = async (id_solicitud, params = {}) => await http_client(`${url}/${id_solicitud}/observaciones`, params, 'get')
const updateSolicitud = async (id_solicitud, params = {}) => await http_client(`${url}/update_state/${id_solicitud}`, params, 'put')

const getSolicitudesByFase = async (id_fase, params = {}) => await http_client(`${url}/aprobacion`, params, 'get')
const updateMoveFase = async (id_fase, params = {}) => await http_client(`${url}/mover-fase/${id_fase}`, params, 'put')
const updateEstadoFase = async (id_fase, params = {}) => await http_client(`${url}/evaluar/${id_fase}`, params, 'put')
const sendSolicitud = async (params = {}) => await http_client(`${url}/iniciar-proceso`, params, 'post')
const putEnviarFase = async (idSoli, body) => await http_client(`${url}/mover-fase/${idSoli}`, body, 'put')
const getSolicitudesFase = async (id_fase, params = {}) => await http_client(`${url}/fase/${id_fase}`, params, 'get')
const getBitacora = async (id_solicitud, params = {}) => await http_client(`${url}/bitacora/${id_solicitud}`, params)
const getPuestoRequisito = async (id_solicitud, params = {}) => await http_client(`${url}/puesto-requisito/${id_solicitud}`, params)
const postPuestoRequisito = async (id_solicitud, params = {}) => await http_client(`${url}/${id_solicitud}/puesto-requisito`, params, 'post')
const deletePuestoRequisito = async (id_solicitud, params = {}) => await http_client(`${url}/${id_solicitud}/puesto-requisito`, params, 'delete')
const getConocimientosYExperiencias = async (id_solicitud, params = {}) => await http_client(`${url}/${id_solicitud}/puesto-requisito`, params,)
const sugerenciaProcesoReclutamiento = async (id_fase, params = {}) => await http_client(`${url}/aprobacion/${id_fase}`, params, 'get')
const getSolicitudesAprobacionByFase = async (id_fase, params = {}) => await http_client(`${url}/aprobacion/${id_fase}`, params, 'get')

const getDocumentsSolicitud = async (id_solicitud_contratacion, params = {}) => await http_client(`${url}/documentos/${id_solicitud_contratacion}`, params, 'get')
const postDocumentsSolicitud = async (id_solicitud_contratacion, body = {}) => await http_client(`${url}/documentos/${id_solicitud_contratacion}`, body, 'post')
const deleteDocumentsSolicitud = async (id_solicitud_contratacion, id_documento) => await http_client(`${url}/documentos/${id_solicitud_contratacion}/${id_documento}`, {}, 'delete')
const downloadDocumentsSolicitud = async (id_solicitud_contratacion, id_documento, tipo_doc) => await http_client(`${url}/documentos/${id_solicitud_contratacion}/${id_documento}/${tipo_doc}`, {}, 'get')

const uploadDcocumentoFirmado = async (id_documento, body = {}) => await http_client(`${url}/documentos-firmado/${id_documento}`, body, 'post')




const obtenerSolicitudesContratacion = async (params = {}) => {
  return await http_client(`/api/v1/solicitud-contratacion`, params, 'get')
}

const obtenerSolicitudesAEvaluar = async (params = {}) => {
  return await http_client(`/api/v1/solicitud-contratacion/solicitudes-a-evaluar`, params, 'get')
}

const validarTabsUsuario = async (params = {}) => {
  return await http_client(`/api/v1/solicitud-contratacion/tabs`, params, 'get')
}

const getPersonasSeleccionadas = async (params = {}) => await http_client(`/api/v2/nombramiento/personas-contratacion`, params, 'get')

const subirDocumentoAutorizacion = async (id_solicitud, body = {}) => {
  return await http_client(`api/v1/solicitud/documentos-solicitud/${id_solicitud}`, body, 'post')
}

const delegarSolicitud = async (id_solicitud, params) => await http_client(`/api/v1/solicitud/delegar-persona/${id_solicitud}?id_empleado_puesto=${params.id_empleado_puesto}`, {}, 'put');

const listarDocReconsideracion = async (id_solicitud, params = {}) => {
  return await http_client(`/api/v1/solicitud/documentos-reconsideracion/${id_solicitud}`, params, 'get');
}

const subirDocReconsideracion = async (id_documento, body = {}) => {
  return await http_client(`/api/v1/solicitud/documento-firmado/${id_documento}`, body, 'post');
}

const verDocReconsideracion = async (id_solicitud, id_documento, params = {}) => {
  return await http_client(`/api/v1/solicitud/documentos-reconsideracion/${id_solicitud}/${id_documento}`, params, 'get');
}

const verDocAutorizacion = async (id_solicitud, params = {}) => {
  return await http_client(`/api/v1/solicitud/documentos-solicitud-detalle/${id_solicitud}`, params, 'get');
}

const verCuadroAportaciones = async (id_solicitud, params = {}) => await http_client(`${url}/reporte/${id_solicitud}`, params, 'get')

const getBitacoraCuadroAportaciones = async (id_solicitud, params = {}) => await http_client(`${url}/${id_solicitud}/bitacora-cuadro-aportaciones`, params, 'get')

const generarDocumentoAutorizacion = async (id_solicitud, body = {}) => {
  const Vue = require('vue').default;
  const token = localStorage.getItem("token");

  return await Vue.prototype.axios({
    method: 'post',
    url: `/api/v1/solicitud/autorizacion-capres-pdf/${id_solicitud}`,
    data: body,
    responseType: 'arraybuffer',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
}

const generarDocumentoContratacionNombramiento = async (id_solicitud) =>
  await http_client(`${url}/documentos/contrato-memoramdum/${id_solicitud}`, {}, 'post');

const getTipoSangre = async (params = {}) => await http_client('/api/v1/catalogos/tipo-sangre', params, 'get')

const getEstadoCivil = async (params = {}) => await http_client('/api/v1/catalogos/estado-civil', params, 'get')
const getPais = async (params = {}) => await http_client('/api/v1/catalogos/pais', params, 'get')
const getDistrito = async (params = {}) => await http_client('/api/v1/catalogos/distrito', params, 'get')
const getSexo = async (params = {}) => await http_client('/api/v1/catalogos/sexo', params, 'get')
const getAcreedor = async (params = {}) => await http_client('/api/v1/catalogos/acreedor', params, 'get')
const getUnidadesSecundarias = async (params = {}) => {
  return await http_client('/api/v1/solicitud/unidades-secundarias', params, 'get')
}
const getUnidadesDestino = async (params = {}) => await http_client('/api/v1/solicitud/unidades-destino', params, 'get')
const getTipoDocumentos = async (params = {}) => await http_client('/api/v1/catalogos/tipo-documentos', params, 'get')
const getTipoContratacion = async (params = {}) => await http_client('/api/v1/catalogos/tipo-contratacion-sol', params, 'get')
const getDepartamentos = async (params = {}) => await http_client('/api/v1/catalogos/departamento-catalogo', params, 'get')

const postCrearSolicitudContratacionDirecta = async (body = {}) => {
  return await http_client(`/api/v1/solicitud/contratacion-directa/solicitud`, body, 'post')
}

const putCrearSolicitudContratacionDirecta = async (id_solicitud, body = {}) => {
  return await http_client(`/api/v1/solicitud/contratacion-directa/solicitud/${id_solicitud}`, body, 'put')
}

const getSolicititudDirecta = async (id_solicitud, params = {}) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/tab`, params, 'get')
}

const deletePersonaSolicitudCD = async (id_solicitud, id_persona) => {
  return await http_client(`/api/v1/solicitud/contratacion-directa/${id_solicitud}/persona/${id_persona}`, {}, 'delete')
}

const obtenerPersonaSolicitudCD = async (id_solicitud, id_persona) => {
  return await http_client(`/api/v1/solicitud/contratacion-directa/${id_solicitud}/persona/${id_persona}`, {})
}

const actualizarPersonaSolicitudCD = async (id_solicitud, id_persona, body = {}) => {
  return await http_client(`/api/v1/solicitud/contratacion-directa/${id_solicitud}/persona/${id_persona}`, body, 'put')
}

const subirDocumentoMemorandumContrato = async (id_solicitud, body = {}) => {
  return await http_client(`api/v1/solicitud/documentos/${id_solicitud}/`, body, 'post')
}

const subirDocumentoMemorandumContratoFirmado = async (id_documento, body = {}) => await http_client(`${url}/documentos-firmado/${id_documento}`, body, 'post')

const verDocumentoMemorandumContrato = async (id_solicitud_contratacion, id_documento, tipo_doc) => (await http_client(`${url}/documentos/${id_solicitud_contratacion}/${id_documento}/${tipo_doc}`, {}, 'get'))

const deleteDocumentoMemorandumContrato = async (id_solicitud_contratacion, id_documento) => await http_client(`${url}/documentos/${id_solicitud_contratacion}/${id_documento}`, {}, 'delete')

const downloadDocumentoMemorandumContrato = async (id_solicitud_contratacion, id_documento, tipo_doc) => await http_client(`${url}/documentos/${id_solicitud_contratacion}/${id_documento}/${tipo_doc}`, {}, 'get')

const listarDocumentosMemorandumContrato = async (id_solicitud, params = {}) => {
  return await http_client(`api/v1/solicitud/documentos-memorandum/${id_solicitud}`, params, 'get')
}

const obtenerEstadoContratacion = async (params) => {
  return await http_client(`/api/v1/solicitud-contratacion/estado-contratacion`, params, 'get')
}

const obtenerValidacionesSolicitudContratacion = async (params = {}) => {
  return await http_client(`/api/v1/solicitud-contratacion/validaciones`, params, 'get')
}

const obtenerDocumentoComprobanteEvaluacion = async (id_evaluacion) => {
  return await http_client(`${bolsa_empleo_url}/api/v1/ofertas/comprobante-evaluacion/${id_evaluacion}`, {}, 'get')
}
const postSeleccionarEmpleados = async (id_solicitud, body, codigo_visualizacion) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/seleccionar-empleados/?codigo_visualizacion=${codigo_visualizacion}`, body, 'post');
}

const postDeclinarPersona = async (id_solicitud, id_persona, body) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/declinar/${id_persona}`, body, 'post')
}

const getPersonasDeclinadas = async (id_solicitud, params) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/declinados`, params, 'get')
}
const getCandidatosElegibles = async (id_solicitud, codigo_visualizacion, params = {}) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/candidatos-elegibles`, { codigo_visualizacion, ...params }, 'get')
}

const postSeleccionarCandidatosElegibles = async (id_solicitud, codigo_visualizacion, body) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/candidatos-bolson/seleccionar?codigo_visualizacion=${codigo_visualizacion}`, body, 'post')
}

const getCandidatosBolson = async (id_solicitud, params = {}) => {
  return await http_client(`/api/v1/solicitud/${id_solicitud}/candidatos-bolson`, params, 'get')
}
const postSolicitudBolson = async (id_solicitud, body) => {
  return await http_client(`/api/v1/solicitud/solicitud-bolson/${id_solicitud}`, body, 'post')
}

const recalcularCuadroAportaciones = async (id_solicitud) => {
  return await http_client(`${url}/${id_solicitud}/recalcular-cuadro-aportaciones`, {}, 'post')
}

const postBitacoraSolicitud = async (id_solicitud, body = {}) =>
  await http_client(`/api/v1/solicitud-contratacion/${id_solicitud}/bitacora`, body, 'post')

const getBitacoraSolicitud = async (id_solicitud, params = {}) =>
  await http_client(`/api/v1/solicitud-contratacion/${id_solicitud}/bitacora`, params, 'get')

const verActaFinalizacion = async (id_acta, fase, params = {}) => await http_client(`${url}/acta-bolson/${id_acta}/${fase}`, params, 'get')

const autogenerarDocumentoMemorandumContrato = async (id_solicitud) => {
  await http_client(`${url}/documentos/memorandum/${id_solicitud}`, {}, 'post')
}


const reemplazarDocumentoContrato = async (id_documento, documento) => await http_client(`${url}/documentos/reemplazar/${id_documento}`, documento, 'post')

export default {
  getSolicitudes,
  getSolicitudesByFase,
  updateMoveFase,
  updateEstadoFase,
  updateSolicitud,
  sendSolicitud,
  getSolicitudesFase,
  getFases,
  putEnviarFase,
  getObservaciones,
  getBitacora,
  getPuestoRequisito,
  postPuestoRequisito,
  deletePuestoRequisito,
  getConocimientosYExperiencias,
  getSolicitudesAprobacionByFase,
  sugerenciaProcesoReclutamiento,
  obtenerSolicitudesContratacion,
  obtenerSolicitudesAEvaluar,
  validarTabsUsuario,
  getDocumentsSolicitud,
  postDocumentsSolicitud,
  deleteDocumentsSolicitud,
  downloadDocumentsSolicitud,
  getPersonasSeleccionadas,
  uploadDcocumentoFirmado,
  subirDocumentoAutorizacion,
  delegarSolicitud,
  listarDocReconsideracion,
  subirDocReconsideracion,
  verDocReconsideracion,
  verDocAutorizacion,
  verCuadroAportaciones,
  getBitacoraCuadroAportaciones,
  generarDocumentoAutorizacion,
  generarDocumentoContratacionNombramiento,
  getTipoSangre,
  getEstadoCivil,
  getPais,
  getDistrito,
  getSexo,
  getAcreedor,
  getUnidadesSecundarias,
  getUnidadesDestino,
  getTipoDocumentos,
  getTipoContratacion,
  postCrearSolicitudContratacionDirecta,
  putCrearSolicitudContratacionDirecta,
  getSolicititudDirecta,
  deletePersonaSolicitudCD,
  obtenerPersonaSolicitudCD,
  actualizarPersonaSolicitudCD,
  getDepartamentos,
  subirDocumentoMemorandumContrato,
  listarDocumentosMemorandumContrato,
  verDocumentoMemorandumContrato,
  deleteDocumentoMemorandumContrato,
  downloadDocumentoMemorandumContrato,
  subirDocumentoMemorandumContratoFirmado,
  obtenerEstadoContratacion,
  obtenerValidacionesSolicitudContratacion,
  obtenerDocumentoComprobanteEvaluacion,
  postSeleccionarEmpleados,
  postDeclinarPersona,
  getPersonasDeclinadas,
  getCandidatosElegibles,
  postSeleccionarCandidatosElegibles,
  getCandidatosBolson,
  postSolicitudBolson,
  recalcularCuadroAportaciones,
  postBitacoraSolicitud,
  getBitacoraSolicitud,
  verActaFinalizacion,
  autogenerarDocumentoMemorandumContrato,
  reemplazarDocumentoContrato
}
